import { useQuery, useMutation } from "@tanstack/react-query";
import { api } from "lib/api";
import { perfilKeys } from "../settings/keys";
import { usePerfilSettings } from "../settings/store";

export function useMisHijos(enabled = true) {
  return useQuery({
    queryKey: perfilKeys.hijos(),
    queryFn: () => api("/perfil/hijos"),
    enabled,
    staleTime: 30_000,
  });
}

export function useCreateHijo() {
  const perfil = usePerfilSettings();
  return useMutation({
    mutationFn: (payload) =>
      api("/perfil/hijos", {
        method: "POST",
        body: JSON.stringify(payload),
      }),
    onSuccess: () => perfil.invalidateHijos(),
  });
}

export function useUpdateHijo() {
  const perfil = usePerfilSettings();
  return useMutation({
    mutationFn: ({ id, patch }) =>
      api(`/perfil/hijos/${id}`, {
        method: "PATCH",
        body: JSON.stringify(patch),
      }),
    onSuccess: () => perfil.invalidateHijos(),
  });
}

export function useDeleteHijo() {
  const perfil = usePerfilSettings();
  return useMutation({
    mutationFn: (id) => api(`/perfil/hijos/${id}`, { method: "DELETE" }),
    onSuccess: () => perfil.invalidateHijos(),
  });
}
